import { useIntl } from "react-intl"
import {Spinner} from 'grommet'
import StatusInfo from "../StatusInfo"

export default function InProgress() {
  const intl = useIntl()

  return (
    <StatusInfo
      text={intl.formatMessage({ id: 'status.inProgress.text' })}
      icon={<Spinner color="brand" size="medium" />}
      secondaryText={intl.formatMessage({ id: 'status.inProgress.secondary' })}
    />
  )
}
